import {focusableSelectors} from "@utils/accessibility/menu";

document.addEventListener('DOMContentLoaded', function() {
    const EVENT_LISTENER_ATTR = 'data-modal-esc-listener-added';

    const modal = document.getElementById('modal-wishlist');
    // Check if listeners are already attached
    if (modal?.hasAttribute(EVENT_LISTENER_ATTR)) {
        return;
    }
    modal?.addEventListener('keydown', (event)=>{
        modal.setAttribute(EVENT_LISTENER_ATTR, 'true');
        if (event.key === 'Escape') {
            modal.querySelectorAll('.modal-close').forEach((button)=>{
                (button as HTMLElement)?.click()
            })
        }
    })
});


const isVisible = (root: HTMLElement, el: HTMLElement | null): boolean => {
    while (el) {
        if(el === root){
            return true
        }
        const style = getComputedStyle(el);
        if (style.display === 'none') return false;
        el = el.parentElement;
    }
    return true;
};


const focusFirstFocusableElement = (element: HTMLElement) => {
    if (!element) return;

    const focusableElements = Array.from(
        element.querySelectorAll<HTMLElement>(focusableSelectors)
    ).filter(el => isVisible(element, el));


    if (focusableElements.length > 0) {
        const firstElement = focusableElements[0];
        firstElement.focus();
    }
};

export {focusFirstFocusableElement}